import { Box, styled, Tooltip, Typography } from "@mui/material";
import { IApproveStatus, statusColor } from "../const";
import { DayType } from "../const"; // Import DayType as a value
import { LeaveType } from "../style";
import { ReactComponent as IconCheckSmall } from "assets/svg/20-check-small.svg";
import { ReactComponent as IconWarning } from "assets/svg/20-warning-outline.svg";
import { ReactComponent as IconInfoCircle } from "assets/svg/20-info-circle.svg";
import { ReactComponent as IconStar } from "assets/svg/20-star.svg";

import { TYPE_LEAVE } from "modules/DeclareLeave/redux/getReasonLeave";
import { BoxIconHoliday } from "modules/DeclareLeave/Pages/Main/DeclareLeaveContent/components/LeaveApplication/style";
import { DayLeaveType as dayType } from "core/http/service/decleareLeave/const";
export interface DayLeaveTypeProps {
  leaveCategory?: string;
  status?: IApproveStatus;
  leaveType?: DayType;
  hexColor: string;
}

export const TypeDayIcon = {
  [dayType.HOLIDAY]: (
    <BoxIconHoliday>
      <IconStar />
    </BoxIconHoliday>
  ),
};

export const ApproveStatusIcon = {
  APPROVE: (
    <Tooltip title={"Đã được phê duyệt"} placement="top">
      <IconCheckSmall />
    </Tooltip>
  ),
  REFUSE: (
    <Tooltip title={"Đã bị từ chối"} placement="top">
      <IconWarning />
    </Tooltip>
  ),
  PENDING: (
    <Tooltip title={"Chưa được phê duyệt"} placement="top">
      <IconInfoCircle />
    </Tooltip>
  ),
};

export const IconBox = styled(Box)<{ status: IApproveStatus }>(
  ({ theme, status }) => ({
    svg: {
      path: {
        fill: statusColor(theme, status, "iconColor"),
      },
    },
  })
);

const DayLeaveType = ({ listLeave }: { listLeave: DayLeaveTypeProps[] }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={1}>
      {(listLeave ?? []).map((item, index) => (
        <LeaveType key={index} iColor={item.hexColor}>
          <Box display={"flex"} gap={0.5} alignItems={"center"}>
            {TypeDayIcon[item.leaveCategory]}
            <Typography color="black" textAlign={"left"}>
              {`${item.leaveCategory} ${item.leaveType === TYPE_LEAVE.HALF_DAY ? "nửa ngày" : ""}`}
            </Typography>
          </Box>
          <IconBox status={item.status}>
            {ApproveStatusIcon[item.status]}
          </IconBox>
        </LeaveType>
      ))}
    </Box>
  );
};

export default DayLeaveType;
